import React, { Component } from "react";
// 接口以及调用接口方法
import { eventMonitoringQry, faultQry } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
// icon
import { ArrowUpOutlined, ArrowDownOutlined, RightOutlined } from "@ant-design/icons";
// 组件

import ExceptionPieChart from "@/pages/displayBoard/exceptionPieChart";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

@connect((state) => state)
class ExceptionBoard extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    console.log(this.props);
    this.state = {
      param: {
        cityIds: this.props.param.cityIds,
        provinceIds: this.props.param.provinceIds, // 默认 000000全国
        date: this.props.param.date,
        operationProperty: this.props.param.operationProperty,
        operationMode: this.props.param.operationMode,
      },
      queryDate1: {
        // 事件
        eventCount: 0, // 事件告警
        eventCountChain: 0, // 事件告警环比
        eventStubCount: 0, // 事件设备
        eventStubCountChain: 0, // 事件设备环比
      },
      queryDate2: {
        // 故障
        faultCount: 0, // 故障告警
        faultCountChain: 0, // 故障告警环比
        faultStubCount: 0, // 故障设备
        faultStubCountChain: 0, // 故障设备环比
      },
    };
  }

  // 页面加载前获取数据
  componentWillMount() {
    this.getEventMonitoringQry();
    this.getFaultQry();
  }

  // 父组件修改param时执行
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.param.provinceIds === this.state.param.provinceIds
      && nextProps.param.cityIds === this.state.param.cityIds
      && nextProps.param.operationProperty === this.state.param.operationProperty
      && nextProps.param.operationMode === this.state.param.operationMode
      && nextProps.param.date === this.state.param.date
    ) {
      console.log("一样");
    } else {
      console.log("不一样");
      this.setState(
        {
          param: {
            cityIds: nextProps.param.cityIds,
            provinceIds: nextProps.param.provinceIds, // 默认 000000全国
            date: nextProps.param.date,
            operationProperty: nextProps.param.operationProperty,
            operationMode: nextProps.param.operationMode,
          },
        },
        () => {
          this.getEventMonitoringQry();
          this.getFaultQry();
        },
      );
    }
  }

  // 获取数据
  getEventMonitoringQry() {
    // 获取成功率数据1
    fetchHandler(eventMonitoringQry, {
      startTime: this.state.param.date,
      cityIds: this.state.param.cityIds,
      operationMode: this.state.param.operationMode,
      operationProperty: this.state.param.operationProperty,
      provinceIds: this.state.param.provinceIds,
    }).then((res) => {
      console.log(res);
      if (res.data) {
        this.setState({
          queryDate1: {
            // 事件
            eventCount: res.data.eventCount, // 事件告警
            eventCountChain: res.data.eventCountChain, // 事件告警环比
            eventStubCount: res.data.eventStubCount, // 事件设备
            eventStubCountChain: res.data.eventStubCountChain, // 事件设备环比
          },
        });
      }
    });
  }

  // 获取数据
  getFaultQry() {
    // 获取成功率数据1
    fetchHandler(faultQry, {
      startTime: this.state.param.date,
      cityIds: this.state.param.cityIds,
      operationMode: this.state.param.operationMode,
      operationProperty: this.state.param.operationProperty,
      provinceIds: this.state.param.provinceIds,
    }).then((res) => {
      console.log(res);
      if (res.data) {
        this.setState({
          queryDate2: {
            // 故障
            faultCount: res.data.faultCount, // 故障告警
            faultCountChain: res.data.faultCountChain, // 故障告警环比
            faultStubCount: res.data.faultStubCount, // 故障设备
            faultStubCountChain: res.data.faultStubCountChain, // 故障设备环比
          },
        });
      }
    });
  }

  /**
   * 新开tab页方法
   */
  openTab = (param, e) => {
    this.props.onAdd(null, e);
  };

  // 数据展示箭头样式设置
  formatterClassBorad = (value) => {
    let className = "";
    if (value === 0) {
      className = "item-rate none";
    } else if (value > 0) {
      className = "down-out-line item-rate";
    } else {
      className = "down-up-line item-rate";
    }
    return className;
  }

  render() {
    const content = (
      <div className="board-inner">
        <div className="order-part pie-part">
          <div className="order-item">
            <div
              className="fixed-more"
              onClick={() => {
                this.openTab(
                  {},
                  {
                    key: "0401",
                    titleText: "故障上报列表",
                  },
                );
              }}>
              {" "}
              详情
              <RightOutlined />{" "}
            </div>
            <div className="item-title">故障告警(次)</div>
            <div className="item-num">{this.state.queryDate2.faultCount}</div>
            <div className={this.formatterClassBorad(this.state.queryDate2.faultCountChain)}>
              环比
              <span className="rate-num">
                {
                 this.state.queryDate2.faultCountChain === 0
                   ? "--"
                   : `${Math.abs(this.state.queryDate2.faultCountChain)}%`
                }
                {
                  this.state.queryDate2.faultCountChain > 0 ? <ArrowUpOutlined /> : null
                }
                {
                  this.state.queryDate2.faultCountChain < 0 ? <ArrowDownOutlined /> : null
                }
              </span>
            </div>
          </div>
          <div className="order-item">
            <div className="item-title">故障设备(台)</div>
            <div className="item-num">{this.state.queryDate2.faultStubCount}</div>
            <div className={this.formatterClassBorad(this.state.queryDate2.faultStubCountChain)}>
              环比
              <span className="rate-num">
                {
                  this.state.queryDate2.faultStubCountChain === 0
                    ? "--"
                    : `${Math.abs(this.state.queryDate2.faultStubCountChain)}%`
                }
                {
                  this.state.queryDate2.faultStubCountChain > 0 ? <ArrowUpOutlined /> : null
                }
                {
                  this.state.queryDate2.faultStubCountChain < 0 ? <ArrowDownOutlined /> : null
                }
              </span>
            </div>
          </div>
          <div className="order-item" style={{ marginBottom: 0 }}>
            <div
              className="fixed-more"
              onClick={() => {
                this.openTab(
                  {},
                  {
                    key: "0402",
                    titleText: "平台事件监控列表",
                  },
                );
              }}>
              {" "}
              详情
              <RightOutlined />{" "}
            </div>
            <div className="item-title">事件告警(次)</div>
            <div className="item-num">{this.state.queryDate1.eventCount}</div>
            <div className={this.formatterClassBorad(this.state.queryDate1.eventCountChain)}>
              环比
              <span className="rate-num">
                {
                  this.state.queryDate1.eventCountChain === 0
                    ? "--"
                    : `${Math.abs(this.state.queryDate1.eventCountChain)}%`
                }
                {
                  this.state.queryDate1.eventCountChain > 0 ? <ArrowUpOutlined /> : null
                }
                {
                  this.state.queryDate1.eventCountChain < 0 ? <ArrowDownOutlined /> : null
                }
              </span>
            </div>
          </div>
          <div className="order-item" style={{ marginBottom: 0 }}>
            <div className="item-title">事件设备(台)</div>
            <div className="item-num">{this.state.queryDate1.eventStubCount}</div>
            <div className={this.formatterClassBorad(this.state.queryDate1.eventStubCountChain)}>
              环比
              <span className="rate-num">
                {
                  this.state.queryDate1.eventStubCountChain === 0
                    ? "--"
                    : `${Math.abs(this.state.queryDate1.eventStubCountChain)}%`
                }
                {
                  this.state.queryDate1.eventStubCountChain > 0 ? <ArrowUpOutlined /> : null
                }
                {
                  this.state.queryDate1.eventStubCountChain < 0 ? <ArrowDownOutlined /> : null
                }
              </span>
            </div>
          </div>
        </div>

        <div className="pie-chart">
          <ExceptionPieChart chartId="gzPie" pieType="1" param={this.state.param} />
          <ExceptionPieChart chartId="gjPie" pieType="2" param={this.state.param} />
        </div>
      </div>
    );

    return content;
  }
}

export default injectIntl(ExceptionBoard);



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/exceptionBoard.js